import { createTypes, createAction } from 'lib/action'
const LOAD_CONTRACTOR_QUOTA = createTypes('loadcontractorquota', 'load')
const EXPORT_CONTRACTOR_QUOTA = createTypes('exportcontractorquota', 'load')
const CONTRACTOR_QUOTA_ORIGIN_LOCATION = createTypes('contractorquotaloadoriginlocation', 'load')
const CONTRACTOR_QUOTA_MATERIAL = createTypes('contractorquotaloadmaterial', 'load')
const CONTRACTOR_QUOTA_MATERIAL_EDIT = createTypes('contractorquotaloadmaterialedit', 'load')
const LOAD_CONTRACTOR = createTypes('contractorquotaloadcontractor', 'load')
const CREATE_CONTRACTOR_QUOTA = createTypes('createcontractorquota', 'create')
const UPDATE_CONTRACTOR_QUOTA = createTypes('updatecontractorquota', 'update')
const CONTRACTOR_QUOTA_PREVIEW = createTypes('contractorQuotaPreview','load')

const REMOVE_LISTS = `REMOVE_LISTS`

function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}

const loadContractorQuota = {
    request: (data, loading) =>
      createAction(LOAD_CONTRACTOR_QUOTA.REQUEST, { data, loading }),
    success: (lists, page) =>
      createAction(LOAD_CONTRACTOR_QUOTA.SUCCESS, { lists, page }),
    failure: () => createAction(LOAD_CONTRACTOR_QUOTA.FAITLURE),
}

const exportContractorQuota = {
    request: (data, loading) =>
      createAction(EXPORT_CONTRACTOR_QUOTA.REQUEST, { data, loading }),
    success: (lists, page) =>
      createAction(EXPORT_CONTRACTOR_QUOTA.SUCCESS, { lists }),
    failure: () => createAction(EXPORT_CONTRACTOR_QUOTA.FAITLURE),
}

// *load ข้อมูลต้นแหล่ง
const loadOriginLocationList = {
  request: (data) =>
    createAction(CONTRACTOR_QUOTA_ORIGIN_LOCATION.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(CONTRACTOR_QUOTA_ORIGIN_LOCATION.SUCCESS, {
      lists,
    }),
  failure: () => createAction(CONTRACTOR_QUOTA_ORIGIN_LOCATION.FAITLURE),
}

// *load ข้อมูลวัตถุดิบ
const loadMaterialList = {
  request: (data) =>
    createAction(CONTRACTOR_QUOTA_MATERIAL.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(CONTRACTOR_QUOTA_MATERIAL.SUCCESS, {
      lists,
    }),
  failure: () => createAction(CONTRACTOR_QUOTA_MATERIAL.FAITLURE),
}

const loadMaterialEditList = {
  request: (data) =>
    createAction(CONTRACTOR_QUOTA_MATERIAL_EDIT.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(CONTRACTOR_QUOTA_MATERIAL_EDIT.SUCCESS, {
      lists,
    }),
  failure: () => createAction(CONTRACTOR_QUOTA_MATERIAL_EDIT.FAITLURE),
}

// *load ข้อมูลผู้รับเหมา
const loadContractorList = {
  request: (data) =>
    createAction(LOAD_CONTRACTOR.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(LOAD_CONTRACTOR.SUCCESS, {
      lists,
    }),
  failure: () => createAction(LOAD_CONTRACTOR.FAITLURE),
}

const createContractorQuota = {
  request: (data, loading) =>
    createAction(CREATE_CONTRACTOR_QUOTA.REQUEST, { data, loading }),
  success: (res) => createAction(CREATE_CONTRACTOR_QUOTA.SUCCESS, { res }),
  failure: () => createAction(CREATE_CONTRACTOR_QUOTA.FAITLURE),
}

const updateContractorQuota = {
  request: (data, loading) =>
    createAction(UPDATE_CONTRACTOR_QUOTA.REQUEST, { data, loading }),
  success: (lists) => createAction(UPDATE_CONTRACTOR_QUOTA.SUCCESS, { lists }),
  failure: () => createAction(UPDATE_CONTRACTOR_QUOTA.FAITLURE),
}

const contractorQuotaPreview = {
  request: (data) =>
    createAction(CONTRACTOR_QUOTA_PREVIEW.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(CONTRACTOR_QUOTA_PREVIEW.SUCCESS, {
      lists,
    }),
  failure: () => createAction(CONTRACTOR_QUOTA_PREVIEW.FAITLURE),
}

export {
    REMOVE_LISTS,
    removeLists,
    LOAD_CONTRACTOR_QUOTA,
    loadContractorQuota,
    EXPORT_CONTRACTOR_QUOTA,
    exportContractorQuota,
    CONTRACTOR_QUOTA_ORIGIN_LOCATION,
    loadOriginLocationList,
    CONTRACTOR_QUOTA_MATERIAL,
    loadMaterialList,
    LOAD_CONTRACTOR,
    loadContractorList,
    CREATE_CONTRACTOR_QUOTA,
    createContractorQuota,
    UPDATE_CONTRACTOR_QUOTA,
    updateContractorQuota,
    CONTRACTOR_QUOTA_PREVIEW,
    contractorQuotaPreview,
    CONTRACTOR_QUOTA_MATERIAL_EDIT,
    loadMaterialEditList
}